import React from 'react';
import { Label } from './Label';

interface TextareaProps extends React.HTMLProps<HTMLTextAreaElement> {
  label: string;
}

const Textarea = React.forwardRef( function TextArea(
  props: TextareaProps, 
  forwarderRef: React.Ref<HTMLTextAreaElement>
)  {
  const { 
    name, 
    label,
    id, 
    className,
    ...rest
  } = props;
  
  const htmlFor = id ? id : `id_input_${name}`;
  
  return (
    <Label htmlFor={htmlFor} label={label} className={className}>
      <textarea {...rest} name={name} id={htmlFor} className={'outline-0 w-full disabled:opacity-50'} ref={forwarderRef} />
    </Label>
  );
});

export default Textarea;